import { render, staticRenderFns } from "./KanbanCard.vue?vue&type=template&id=b7f5f860&scoped=true"
import script from "./KanbanCard.vue?vue&type=script&lang=js"
export * from "./KanbanCard.vue?vue&type=script&lang=js"
import style0 from "./KanbanCard.vue?vue&type=style&index=0&id=b7f5f860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f5f860",
  null
  
)

export default component.exports